export default __webpack_public_path__ + "static/112-4a95a2ca62f9ad6f69d6e3db05a7f931.jpg";